export default function LoadingSpinner() {
  return (
    <div className="d-flex justify-content-center align-items-center py-5">
      <div className="spinner-border" style={{ color: 'var(--wh-accent)' }} role="status">
        <span className="visually-hidden">Carregando...</span>
      </div>
    </div>
  );
}
